// Dependecies
//
var $ = require('jquery');


// Add validation rule
//
$.validator.addMethod("phoneCA", function (phone_number, element) {
    phone_number = phone_number.replace(/\s+/g, "");
    return this.optional(element) || phone_number.length > 9 &&
        phone_number.match(/^(1-?)?(\([2-9]\d{2}\)|[2-9]\d{2})-?[2-9]\d{2}-?\d{4}$/);
}, $.validator.messages.phoneUS);

$.validator.addMethod("postalCodeCA", function (postal, element) {
    return this.optional(element) ||
    postal.match(/[a-zA-Z][0-9][a-zA-Z](-| |)[0-9][a-zA-Z][0-9]/);
}, $.validator.messages.postalCodeCA);

$.validator.addMethod("validEmail", function (value, element) {
        return /\S+@\S+\.\S+/.test(value);
    }, $.validator.messages.email
);


// Bind validation rule to a class
//
$.validator.addClassRules("postal-code-ca", {
    postalCodeCA: true
});

$.validator.addClassRules("phone-ca", {
    phoneCA: true
});

$.validator.addClassRules("valid-email", {
    validEmail: true
});

$.validator.addClassRules("valid-number", {
    digits: true
});


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/forms-validation/validation.js
 ** module id = 52
 ** module chunks = 0 1
 **/